import React from 'react';
import {motion} from 'framer-motion';
import {useTranslation} from 'react-i18next';

// Bandeau "lot tirs au but" affiché sur l'écran de résultat. Cliquable (→ QR) si AVAILABLE,
// sinon badge de rappel (récupéré / expiré). Calqué sur HalfTimeRewardBanner.
export const PenaltyRewardBanner = ({penaltyReward, onShow = () => {}, className = ''}) => {
    const {t} = useTranslation();

    if (!penaltyReward) return null;

    const isAvailable = penaltyReward.status === 'AVAILABLE';
    const isConsumed = penaltyReward.status === 'CONSUMED';

    const visual = isAvailable
        ? {
            icon: '⚽', iconBox: 'bg-emerald-500/20 border-emerald-400/30',
            shadow: 'shadow-[0_8px_24px_-8px_rgba(16,185,129,0.5)]',
            title: t('penalty.reward_title', 'Ton lot tirs au but'),
            sub: t('penalty.reward_sub', 'À récupérer au comptoir')
        }
        : isConsumed
            ? {
                icon: '✅', iconBox: 'bg-action-green/20 border-action-green/30', shadow: '',
                title: t('penalty.reward_title_consumed', 'Lot tirs au but récupéré'),
                sub: t('penalty.reward_sub_consumed', 'Quel sang-froid !')
            }
            : {
                icon: '⌛', iconBox: 'bg-white/10 border-white/15', shadow: '',
                title: t('penalty.reward_title_expired', 'Lot tirs au but expiré'),
                sub: t('penalty.reward_sub_expired', 'Le délai est passé')
            };

    return (
        <motion.button
            initial={{opacity: 0, y: -10}}
            animate={{opacity: 1, y: 0}}
            onClick={isAvailable ? onShow : undefined}
            disabled={!isAvailable}
            className={`w-full flex items-center justify-between gap-3 bg-brand-dark text-white rounded-2xl px-4 py-3 ${visual.shadow} ${isAvailable ? 'active:scale-[0.98] cursor-pointer' : 'opacity-80 cursor-default'} transition-transform ${className}`}
        >
            <span className="flex items-center gap-2.5">
                <span className={`w-8 h-8 rounded-full border flex items-center justify-center text-base shrink-0 ${visual.iconBox}`}>{visual.icon}</span>
                <span className="text-left">
                    <span className="block text-sm font-black leading-tight">{visual.title}</span>
                    <span className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">{visual.sub}</span>
                </span>
            </span>
            {isAvailable && (
                <span className="text-xs font-black text-emerald-300 uppercase tracking-widest shrink-0">
                    {t('penalty.reward_cta', 'Voir')} →
                </span>
            )}
        </motion.button>
    );
};
